import { validateAgency } from '@shared/common/data-validators/agency.validator';
import { User } from '@/modules/user/user';
export class Agency {

    public get fullname(): string {
        return `${this.code} - ${this.label}`;
    }

    public static validate(data: any): string[] {
        return validateAgency(data);
    }
    public id!: string;
    public code!: string;
    public label!: string;
    public createdAt!: Date;
    public updatedAt!: Date;
    public createdBy?: User;
    public updatedBy?: User;

    constructor(opt: any) {
        Object.assign(this, opt);
    }
}
